import React, {useRef, useEffect, Fragment} from 'react';
import {get, range, identity, useField} from 'helpers';
import css from './slider.module.scss';

export function Slider({ min = 0, max, filled, options, disabled, ...props }) {
  const ref = useRef();
  const [ input, , {  setValue} ] = useField(props);
  const getLabel = get(options, 'label', identity);
  const ratio = (input.value - min) / (max - min);

  filled && useEffect(() => {
    ref.current.style.background = `linear-gradient(90deg, var(--filled-color) ${ratio*100}%, var(--subtle) ${ratio*100}%)`;
  }, [ input.value ]);

  return (
    <span className={css('wrapper', props, filled == 'colored' && getColor(ratio), { disabled })}>
      <input ref={ref} type="range" className={css.slider} {...input} min={min} max={max} />
      { options &&
        <span className={css.options}>
          { range(min, max + 1).map(option =>
            <span className={css('option-anchor')} key={option} onClick={() => setValue(option)}>
              <span className={css('option', option == input.value && 'selected')}>
                { getLabel(option) }
              </span>
            </span>
          ) }
        </span>
      }
      { filled &&
        <Fragment>
          <span className={css('print-track')} />
          <span className={css('print-filled')} style={{ width: `${ratio*100}%` }} />
        </Fragment>
      }
    </span>
  );
}

function getColor(ratio) {
  if (ratio < 0.33) {
    return 'danger';
  }
  return ratio > 0.66 ? 'green' : 'alert';
}
